/**
 * useCheckoutSuccess — Stripe-return detection + UX follow-up.
 *
 * After a successful checkout Stripe redirects back to the app with
 * `?checkout=success` in the URL. This hook owns:
 *  - detecting that flag once on mount
 *  - clearing it from the URL (no re-entry on refresh)
 *  - firing a `user-invalidate` bus event so UserProvider refetches
 *    the new plan/access snapshot
 *  - exposing an `open` boolean + `close()` for a success modal
 *
 * Extracted from App.tsx to keep the shell thin.
 */

import { useEffect, useState } from 'react';
import { emit as emitAppEvent } from '../events/bus';

export function useCheckoutSuccess(): { open: boolean; close: () => void } {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const params = new URLSearchParams(window.location.search);
        if (params.get('checkout') === 'success') {
            window.history.replaceState({}, '', window.location.pathname);
            emitAppEvent('user-invalidate', { reason: 'checkout' });
            setOpen(true);
        }
    }, []);

    return { open, close: () => setOpen(false) };
}
